var exports = {
  "$": "x4c3adb35--15525a--search",
  "Q": "x4c3adb35--15525a--content",
};

module.exports = exports;
